import React, { FunctionComponent } from 'react';

import styles from './PostCardTextContent.module.scss';
import { getFromLocalStorage } from 'app/utils/localStorage';
import { useHistory } from 'react-router-dom';
import { parseMentions } from 'app/utils/pasreMentions';
import {
  useHandleNavigateInfluencerOrEntity,
  useOpenModalToAddUserAsInfluencer,
} from 'app/utils/check-influencer-user';
import { TMutation } from 'app/Requests/types';

interface Props {
  isContentClickable?: boolean;
  isReport?: boolean;
  detailsUrl?: string;
  isTranslated?: boolean;
  content: { original: string; arabic: string } | string;
  mentions?: Record<string, any>[];
  openText?: string;
  content_translated?: string;
  storeInfluencerName?: ({ username }: TMutation<string>) => Promise<any>;
}

const PostCardTextContent: FunctionComponent<Props> = ({
  isContentClickable,
  isReport,
  detailsUrl,
  isTranslated,
  content,
  mentions,
  storeInfluencerName,
  openText,
  content_translated,
}) => {
  const history = useHistory();
  const isEn = !!(getFromLocalStorage('LNG') == 'en');
  const [openModalToAddUserAsInfluencer] = useOpenModalToAddUserAsInfluencer(
    storeInfluencerName!,
  );
  const [handleNavigateInfluencerOrEntity] =
    useHandleNavigateInfluencerOrEntity();
  return (
    <div
      className={`${styles.PostCardTextContent} ${!isReport && isContentClickable ? 'cursor-pointer' : ''}`}
      onClick={() =>
        !isReport && isContentClickable && history.push(detailsUrl)
      }
    >
      <div className="post_card_content">
        {parseMentions(
          typeof content === 'string'
            ? !content_translated?.length
              ? content
              : (!isTranslated && isEn) || (!isEn && isTranslated)
                ? content
                : content_translated!
            : !content?.arabic?.length
              ? content?.original
              : (!isTranslated && isEn) || (!isEn && isTranslated)
                ? content?.original
                : content?.arabic,
          (postUrl, userUsername) =>
            openModalToAddUserAsInfluencer(userUsername, postUrl, openText),
          (infData) => handleNavigateInfluencerOrEntity(infData),
          mentions,
        )}
      </div>
    </div>
  );
};

export default PostCardTextContent;
